import {Box, Text, Button, Center, Flex, Image} from '@chakra-ui/react';
import {useState} from 'react';
import {useRouter} from 'next/router';
import {useAppToast} from '../hooks/app-toast';
import {PageLayout} from '../components/global/page-layout';
import {
  useUserQuery,
  useUpdateUserDisplayedSideAssetMutation,
} from '../graphql/generated';
import {REIGNING_QUEENS_ID, Routes} from '../shared/consts';

export const PORTRAITS = [
  {
    imageSrc: '/assets/warhol-card-1.png',
    id: 1,
  },
  {
    imageSrc: '/assets/warhol-card-2.png',
    id: 2,
  },
  {
    imageSrc: '/assets/warhol-card-3.png',
    id: 3,
  },
  {
    imageSrc: '/assets/warhol-card-4.png',
    id: 4,
  },
];

const ChooseMyPortrait: React.FC = () => {
  const userQuery = useUserQuery();
  const toast = useAppToast();
  const router = useRouter();

  const [activePortrait, setActivePortrait] = useState<number>(0);

  const [updateUserDisplayedSideAsset, {loading}] =
    useUpdateUserDisplayedSideAssetMutation();

  const handleCertificate = () => {
    updateUserDisplayedSideAsset({
      variables: {
        assetId: REIGNING_QUEENS_ID,
        side: activePortrait,
      },
    })
      .then(() => {
        router.push(
          `${Routes.MY_COLLECTION}?certificate=1&piece=${REIGNING_QUEENS_ID}`,
        );
      })
      .catch((error) => {
        toast.showErrorToast(error);
      });
  };
  return (
    <PageLayout firstName={userQuery.data?.user?.firstName}>
      <Box
        textAlign="center"
        mb="64px"
        mt={{base: '0px', lg: '60px'}}
        px={{base: '37px', md: '170px', lg: '300px'}}
      >
        <Text as="h2" textStyle={{base: 'h6', lg: 'h4'}}>
          How do you want the portrait to show in your collection? Select one.
        </Text>
      </Box>
      <Flex
        alignItems="center"
        justifyContent="center"
        flexWrap={{base: 'wrap', md: 'nowrap'}}
        maxWidth={{base: '400px', md: '768px'}}
        margin="0 auto"
      >
        {PORTRAITS.map((img: any) => (
          <Box
            px={{base: '8px', lg: '11px'}}
            key={img.imageSrc}
            width={{base: '50%', md: '100%'}}
          >
            <Box
              alignItems="center"
              justifyContent="center"
              cursor="pointer"
              border="5px solid white"
              borderColor={activePortrait === img.id ? 'aqua.500' : 'white'}
              borderRadius="8px"
              as="button"
              onClick={() => setActivePortrait(img.id)}
            >
              <Image src={img.imageSrc} borderRadius="8px" alt="portrait" />
            </Box>
          </Box>
        ))}
      </Flex>
      <Center mt={{base: '40px', lg: '100px'}}>
        <Button
          colorScheme="aqua"
          size="lg"
          w={{base: 'medium', lg: 'full'}}
          maxW="400px"
          onClick={handleCertificate}
          disabled={loading}
        >
          Continue to view my certificate
        </Button>
      </Center>
    </PageLayout>
  );
};

export default ChooseMyPortrait;
